import {Routes} from "@angular/router";
import {authGuard} from "./core/guards/auth.guard";
export const routes: Routes = [
  { path: 'principal', canActivate: [ authGuard ], loadComponent: () => import('./componentes/principal/principal.component').then(c => c.PrincipalComponent) },
  { path: 'login-form', loadComponent: () => import('./componentes/autenticacion/login-form/login-form.component').then(c => c.LoginFormComponent) },
  { path: 'code', loadComponent: () => import('./componentes/autenticacion/code/code.component').then(c => c.CodeComponent) },
  { path: '**', redirectTo: 'login-form' }
];
